import React, { useEffect } from 'react';
import { I18n } from '@lingui/core';

import { getLocalI18n } from '$/shared/frontend/utils/i18n';

export const useLocalI18n = (language?: string): I18n | undefined => {
  const [localI18n, setLocalI18n] = React.useState<I18n>();

  const loadLocalI18n = React.useCallback(async (): Promise<void> => {
    if (language && !localI18n) {
      setLocalI18n(await getLocalI18n(language));
    }
  }, [language, localI18n]);

  useEffect(() => {
    loadLocalI18n();
  }, [loadLocalI18n]);
  return localI18n;
};
